<template>
  <v-container fluid grid-list-md style="padding: 35px;" id="create">
    <v-flex xs12 sm12 md12 lg12>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <p class="textoUser">DASHBOARD - GIFTLIST</p>
        </v-col>
        <v-col cols="12" sm="12" md="2">
          <v-speed-dial v-model="fab" top right direction="left" transition="slide-y-reverse-transition" class="py-0" style="margin-right: 16px;">
            <template v-slot:activator>
              <v-btn v-model="fab" color="#7B1FA2" dark fab>
                <v-icon large>swap_vert</v-icon>
              </v-btn>
            </template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn fab v-on="on" dark @click="openDialog('CHECKIN')" color="#388E3C">
                  <v-icon large>arrow_circle_down</v-icon>
                </v-btn>
              </template>
              <span>CheckIn</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn fab dark v-on="on" color="#D32F2F" @click="openDialog('CHECKOUT')">
                  <v-icon large>arrow_circle_up</v-icon>
                </v-btn>
              </template>
              <span>CheckOut</span>
            </v-tooltip>
          </v-speed-dial>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#7B1FA2" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Total</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Convidados</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 30px; padding: 12px;">{{quantidadeConvidados}}</v-card-text>
              </div>
              <v-avatar size="120">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="100" color="white">100%</v-progress-circular>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#00af45" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Convidados</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Confirmados</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 30px; padding: 12px;">{{convidadosConfirmados}}</v-card-text>
              </div>
              <v-avatar size="120">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="percenteReserv" color="white">{{ percenteReserv.toFixed(0) }}%</v-progress-circular>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#F4511E" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Convidados</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Não Confirmados</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 30px; padding: 12px;">{{convidadosNaoConfirmados}}</v-card-text>
              </div>
              <v-avatar size="120">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="percentInscri" color="white">{{ percentInscri.toFixed(0) }}%</v-progress-circular>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#FFA000" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Convidados</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Sem confirmação</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 30px; padding: 12px;">{{convidadosSemConfirmacao}}</v-card-text>
              </div>
              <v-avatar size="120">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="percentConfirm" color="white">{{ percentConfirm.toFixed(0) }}%</v-progress-circular>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#ab34eb" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Senhas Extra</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Quantidade</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 30px; padding: 12px;">{{qtdSenhasExtra}}</v-card-text>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#0097A7" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Valor</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Presentes</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 30px; padding: 12px;">R$ {{valorPresentes}}</v-card-text>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#006064" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Disponível</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Saque</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 30px; padding: 12px;">R$ {{valorSaque}}</v-card-text>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#4169E1" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="">Meus Checkins</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Realizados</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 30px; padding: 12px;">{{checkinsRealizados}}</v-card-text>
              </div>
              <v-avatar size="120">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="percentCheckinUser" color="white">{{ percentCheckinUser.toFixed(0) }}%</v-progress-circular>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#A84848" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="">Total Checkins</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Realizados</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size: 30px; padding: 12px;">{{checkinsRealizadosTotal}}</v-card-text>
              </div>
              <v-avatar size="120">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="percentCheckinTotal" color="white">{{ percentCheckinTotal.toFixed(0) }}%</v-progress-circular>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-dialog v-model="dialog" max-width="350px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto" style="margin-bottom: -23px">{{acao}}</span>
            </v-card-title>
            <v-card-text v-if="!validacao" style="text-align: center;padding: 0px 5px 0px">
              <v-container>
                <v-row align="center" justify="center" v-if="acao=='CHECKOUT'">
                  <v-col cols="12" sm="6" md="12">
                    <p class="texto" :style="`color:${corValidacao}`">{{evento}}</p>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" v-if="acao=='CHECKIN'">
                  <!-- <v-col cols="12" sm="6" md="12">
                    <v-radio-group v-model="tipo" row hide-details>
                      <v-radio color="#7B1FA2" label="QRCODE" value="1"></v-radio>
                      <v-radio color="#7B1FA2" label="CÓDIGO" value="2"></v-radio>
                      <v-radio color="#7B1FA2" label="CPF" value="3"></v-radio>
                    </v-radio-group>
                  </v-col> -->
                  <v-col cols="12" sm="6" md="12" v-if="tipo=='1'">
                    <qrcode-stream @decode="onDecode"></qrcode-stream>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" v-if="tipo=='2'">
                    <v-text-field light label="CÓDIGO" color="#7B1FA2" type="tel" outlined hide-details dense v-model="codigo"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" v-if="tipo=='3'">
                    <v-text-field light label="CPF" color="#7B1FA2" outlined v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="cpf"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-text v-if="validacao" style="text-align: center;padding: 0px 5px 0px;">
              <v-container>
                <br>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <v-icon large :color="corValidacao" style="font-size: 100px">{{iconValidacao}}</v-icon>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" style="padding: 2px;" v-if="senhasExtra > 0">
                    <p class="texto" :style="`color:${corValidacaoSenhasExtra}; font-size: 20px; background-color: ${corValidacao}; padding: 10px`">
                      <b v-if="senhasExtra == 1">{{senhasExtra}} senha extra</b>
                      <b v-if="senhasExtra > 1">{{senhasExtra}} senhas extras</b>
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" :style="`color:${corValidacao}; font-size: 17px`"><b>{{msgValidacao}}</b></p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions v-if="!validacao" style="margin-top: -32px;padding: 20px 5px 0px;">
              <v-container fluid grid-list-md>
                <v-layout row wrap justify-center>
                  <v-flex xs6 sm6 lg6 v-if="tipo!=1">
                    <v-btn :loading="loading" dark depressed block color="#4A148C" style="border-radius: 7px;" large @click="validarInscricao">Validar</v-btn>
                  </v-flex>
                  <v-flex xs6 sm6 lg6>
                    <v-btn dark depressed block color="#D32F2F" style="border-radius: 7px;" large @click="close">Fechar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
            <v-card-actions v-if="validacao" style="margin-top: -32px;padding: 20px 5px 0px;">
              <v-container fluid grid-list-md>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm12 lg12>
                    <v-btn dark depressed block color="#4A148C" style="border-radius: 7px;" large @click="closeResultado">Fechar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-flex>
    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  export default {
    components: { Snackbar, Loading },
    data() {
      return {
        diasSelc: 7,
        corSelec: '#388E3C',
        fab: false,
        fullPage: true,
        isLoading: false,
        eventoId: '',
        eventos: [],
        quantidadeConvidados: 0,
        convidadosNaoConfirmados: 0,
        convidadosSemConfirmacao: 0,
        checkinsRealizados: 0,
        checkinsRealizadosTotal: 0,
        convidadosConfirmados: 0,
        confirmados: 0,
        percentCapac: 0,
        percenteReserv: 0,
        percentInscri: 0,
        percentConfirm: 0,
        percentCheckinTotal: 0,
        percentCheckinUser: 0,
        percentualApoio: 0,
        percentualBasico: 0,
        percentualGrandesEventos: 0,
        percentualAtivo: 0,
        percentualEmAnalise: 0,
        percentExtra: 0,
        qtdSenhasExtra: 0,
        dialog: false,
        codigo: '',
        cpf: '',
        tipo: '1',
        acao: '',
        evento: '',
        validacao: false,
        loading: false,
        msgValidacao: '',
        iconValidacao: '',
        corValidacao: '',
        contador: '',
        checkin: {
          codigo: '',
          tipo: '',
          empresaId: '',
          userValidatorId: '',
        },
        defaultCheckin: {
          codigo: '',
          tipo: '',
          empresaId: '',
          userValidatorId: '',
        },
        audio: '',
        usaQrcode: false,
        senhasExtra: 0,
        corValidacaoSenhasExtra: '#FFFFFF',
        valorPresentes: 0.00,
        valorSaque: 0.00,
      }
    },

    computed: {
      ...mapState({
        usuarioadmin: state => state.Userpermission,
        usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj,
      }),
    },

    mounted() {
      //this.carregaDados()
      //this.inscricoesVigilantes()
      this.carregaQuantidades()
      this.carregaValorPresentes()
      this.carregaQuantidadeCheckins()
      this.audio = new Audio(require("../assets/beep.mp3"))
      this.$validator.localize('pt', this.dictionary)
    },

    watch: {
      tipo(val) {
        if (val === '1') {
          this.cpf = ""
          this.$validator.reset()
        } else if (val === '2')
          this.codigo = ''
      }
    },

    methods: {
      onDecode(decodedString) {
        this.codigo = decodedString
        this.usaQrcode = true
        this.confirmaCheckin()
      },

      async carregaDados() {
        this.isLoading = true
        await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"${this.companyobj.id}"},{"ativo":"true"}]}}`)
        .then(res => {
          if (res.data != '') {
            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                if (moment(this.formatDateHora(res.data[key].fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format()) {
                  this.eventos.push(res.data[key])
                }
              }
            }
            this.eventos = this.eventos.sort(this.compare)
            this.eventoId = this.eventos[0].id
          } else {
            this.isLoading = false
          }
        })
        await this.carregaValores()
      },

      formatDateBrz(date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null
        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDate(date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHora(date) {
        if (!date) return null
        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },
      
      compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const dataA = a.fim;
        const dataB = b.fim;

        let comparison = 0;
        if (dataA > dataB) {
          comparison = 1;
        } else if (dataA < dataB) {
          comparison = -1;
        }
        return comparison;
      },

      openDialog(acao) {
        if (acao == 'CHECKIN') {
          this.tipo = "1"
          this.audio.play()
        } else
          this.tipo = "0"
        this.codigo = ''
        this.cpf = ''
        this.acao = acao
        this.dialog = true
      },

      async validarInscricao() {
        this.checkin = Object.assign({}, this.defaultCheckin)
        this.loading = true
        if (this.acao == 'CHECKIN') {
          this.confirmaCheckin()
        } else
        if (this.acao == 'CHECKOUT') {
          this.confirmaCheckout()
        } else {
          this.loading = false
        }
      },

      async confirmaCheckin() {
        var vm = this;
        if (this.codigo != '') {
          this.checkin.codigo = this.codigo
        this.checkin.tipo = this.acao
        this.checkin.empresaId = this.companyobj.id
        this.checkin.userValidatorId = this.user.id
          await axios.post(`${baseApiUrl}Convidados/checkin`, this.checkin)
            .then(res => {
              if (res.data != '') {
                switch (res.data.codigo) {
                  case 1:
                    //'Validação já efetuada anteriormente' 
                    if (this.usaQrcode)
                      this.audio.play()
                    this.senhasExtra = res.data.senhasExtra
                    this.msgValidacao = res.data.resposta
                    this.iconValidacao = 'error_outline'
                    this.corValidacao = '#FF8F00'
                    this.validacao = true
                    this.loading = false
                    this.usaQrcode = false
                    break;
                  case 2:
                    //'Vagas esgotadas para o evento'
                    if (this.usaQrcode)
                      this.audio.play()
                    this.msgValidacao = res.data.resposta
                    this.iconValidacao = 'cancel'
                    this.corValidacao = '#D32F2F'
                    this.validacao = true
                    this.loading = false
                    this.usaQrcode = false
                    break;
                  case 3:
                    //'Validação efetuada com sucesso'
                    if (this.usaQrcode)
                      this.audio.play()
                    this.senhasExtra = res.data.senhasExtra
                    this.msgValidacao = res.data.resposta
                    this.iconValidacao = 'check_circle_outline'
                    this.corValidacao = '#43A047'
                    this.validacao = true
                    this.loading = false
                    this.usaQrcode = false
                    break;
                  case 5:
                    //'Inscrição não localizada pra este evento'
                    if (this.usaQrcode)
                      this.audio.play()
                    this.msgValidacao = res.data.resposta
                    this.iconValidacao = 'cancel'
                    this.corValidacao = '#D32F2F'
                    this.validacao = true
                    this.loading = false
                    this.usaQrcode = false
                    break;
                  case 8:
                    //'Inscrição com pagamento pendente'
                    if (this.usaQrcode)
                      this.audio.play()
                    this.msgValidacao = res.data.resposta
                    this.iconValidacao = 'error_outline'
                    this.corValidacao = '#FF8F00'
                    this.validacao = true
                    this.loading = false
                    this.usaQrcode = false
                    break;
                  default:
                    this.validacao = true
                    this.loading = false
                    this.usaQrcode = false
                    break;
                }
              }
            }).catch(() => {
              this.isLoading = false
              this.close()
              vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar check-in, tente novamente", "DESCULPE")
            })
        } else
        if (this.cpf != '') {
          await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"cpf":"${this.cpf}"},{"eventoId":"${this.eventoId}"}]}}`)
            .then(res => {
              if (res.data != '') {
                this.checkin.codigo = res.data[0].codigo
              } else {
                this.checkin.codigo = 9999
              }
            })

          this.checkin.tipo = this.acao
          this.checkin.empresaId = this.companyobj.id
          this.checkin.userValidatorId = this.user.id
          await axios.post(`${baseApiUrl}Convidados/checkin`, this.checkin)
            .then(res => {
              if (res.data != '') {
                switch (res.data.codigo) {
                  case 1:
                    //'Validação já efetuada anteriormente'                    
                    this.senhasExtra = res.data.senhasExtra
                    this.msgValidacao = res.data.resposta
                    this.iconValidacao = 'error_outline'
                    this.corValidacao = '#FF8F00'
                    this.validacao = true
                    this.loading = false
                    break;
                  case 3:
                    //'Validação efetuada com sucesso'                    
                    this.senhasExtra = res.data.senhasExtra
                    this.msgValidacao = res.data.resposta
                    this.iconValidacao = 'check_circle_outline'
                    this.corValidacao = '#43A047'
                    this.validacao = true
                    this.loading = false
                    break;
                  case 5:
                    //'Inscrição não localizada pra este evento'                    
                    this.msgValidacao = res.data.resposta
                    this.iconValidacao = 'cancel'
                    this.corValidacao = '#D32F2F'
                    this.validacao = true
                    this.loading = false
                    break;
                  case 8:
                    //'Inscrição com pagamento pendente'
                    this.msgValidacao = res.data.resposta
                    this.iconValidacao = 'error_outline'
                    this.corValidacao = '#FF8F00'
                    this.validacao = true
                    this.loading = false
                    this.usaQrcode = false
                    break;
                  default:
                    break;
                }
              }
            }).catch(() => {
              this.isLoading = false
              this.close()
              vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar check-in, tente novamente", "DESCULPE")
            })
        } else
          this.loading = false
        this.checkin.codigo = ''
        this.checkin.tipo = ''
        this.checkin.empresaId = ''
      },

      async confirmaCheckout() {
        this.checkin.codigo = this.codigo
        this.checkin.tipo = this.acao
        this.checkin.empresaId = this.companyobj.id
        await axios.post(`${baseApiUrl}inscricoes/checkin`, this.checkin)
          .then(res => {
            if (res.data != '') {
              switch (res.data.codigo) {
                case 7:
                  //'Checkout confirmado
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'check_circle_outline'
                  this.corValidacao = '#43A047'
                  this.validacao = true
                  this.loading = false
                  break;
                case 6:
                  //'O local do evento está vazio'
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'error_outline'
                  this.corValidacao = '#FF8F00'
                  this.validacao = true
                  this.loading = false
                  break;
                default:
                  break;
              }
              this.checkin.codigo = ''
              this.checkin.tipo = ''
              this.checkin.empresaId = ''
            }
          })
      },

      async carregaValores() {
        for (var key in this.eventos) {
          if (this.eventos.hasOwnProperty(key)) {
            if (this.eventos[key].id == this.eventoId) {
              this.quantidadeConvidados = this.eventos[key].vagas
              this.convidadosConfirmados = this.eventos[key].reserva
              this.evento = this.eventos[key].nome
            }

          }
        }

        // obtém a quantidade de inscrições realizadas e pagas
        await axios.post(`${baseApiUrl}Inscricoes/dashboard`, {"eventoId": this.eventoId})
        .then(res => {
          this.convidadosNaoConfirmados = res.data.convidadosNaoConfirmados
          this.convidadosSemConfirmacao = res.data.confirmados
        })

        try {
          let res = await axios.get(`${baseApiUrl}Convidados?filter={"where":{"eventoId":"${this.eventoId}"}}`)
              let inscricoes = res.data
              //this.checkinsRealizados = res.data
              inscricoes.forEach(inscrito => {
                if(inscrito.checkin != null && inscrito.userValidatorCheckinId == this.user.id){
                  if(inscrito.hasOwnProperty("senhasExtra") && inscrito.senhasExtra > 0)
                      this.checkinsRealizados = this.checkinsRealizados + inscrito.senhasExtra
                  else
                      this.checkinsRealizados++
                }

                if(inscrito.checkin != null){
                  if(inscrito.hasOwnProperty("senhasExtra") && inscrito.senhasExtra > 0)
                      this.checkinsRealizadosTotal = this.checkinsRealizadosTotal + inscrito.senhasExtra
                  else
                      this.checkinsRealizadosTotal++
                }
                
              });            
        } catch (error) {
          //
        }

        await this.calculaPercentuais()

      },

      async carregaQuantidades() {
        await axios.get(`${baseApiUrl}Convidados/count?where={"empresaId":"${this.companyobj.id}"}`).then(response => {
          this.quantidadeConvidados = response.data.count
        })
        await axios.get(`${baseApiUrl}Convidados/count?where={"and":[{"empresaId":"${this.companyobj.id}"},{"confirmacao":true}]}`).then(response => {
          this.convidadosConfirmados = response.data.count
        })
        await axios.get(`${baseApiUrl}Convidados/count?where={"and":[{"empresaId":"${this.companyobj.id}"},{"confirmacao":false}]}`).then(response => {
          this.convidadosNaoConfirmados = response.data.count
        })
        await axios.get(`${baseApiUrl}Convidados/count?where={"and":[{"empresaId":"${this.companyobj.id}"},{"confirmacao":null}]}`).then(response => {
          this.convidadosSemConfirmacao = response.data.count
        })
        await axios.get(`${baseApiUrl}Convidados?filter={"where":{"empresaId":"${this.companyobj.id}"}, "fields":{"senhasExtra": true}}`).then(response => {
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].senhasExtra) {
              this.qtdSenhasExtra += parseInt(response.data[i].senhasExtra)
            }
          }
        })
        /* await axios.get(`${baseApiUrl}Pedidos/count?where={"and":[{"empresaId":"${this.companyobj.id}"},{"statusPagamento":"PAGO"}]}`).then(response => {
          this.qtdGrandesEventos = response.data.count
        }) */
        await this.calculaPercentuais()
      },

      async calculaPercentuais() {
        this.percenteReserv = this.convidadosConfirmados * 100 / this.quantidadeConvidados
        this.percentInscri = this.convidadosNaoConfirmados * 100 / this.quantidadeConvidados
        // this.percentConfirm = this.confirmados * 100 / this.quantidadeConvidados
        this.percentConfirm = this.convidadosSemConfirmacao * 100 / this.quantidadeConvidados
        this.percentCheckinTotal = this.checkinsRealizadosTotal * 100 / this.quantidadeConvidados
        this.percentCheckinUser = this.checkinsRealizados * 100 / this.quantidadeConvidados
        this.isLoading = false
      },

      close() {
        this.tipo = 0
        this.dialog = false
        this.corValidacao = '#424f4e'
        setTimeout(() => {
          this.validacao = false
        }, 300);
      },

      closeResultado() {
        if (this.acao == 'CHECKIN') {
          this.tipo = "1"
          this.validacao = false
          this.corValidacao = '#424f4e'
          this.participantes = 0
        } else
          this.close()
        //this.tipo = 1
      },

      async carregaValorPresentes() {
        await axios.get(baseApiUrl + 'Pedidos?filter={"where":{"and":[{"empresaId":"'+this.companyobj.id+'"},{"statusPagamento":"PAGO"}]}, "fields":{"id": true, "valor": true}}')
        .then(response => {
          if (response.data.length > 0) {
            this.valorPresentes = 0.00
            for (let i = 0; i < response.data.length; i++) {
              this.valorPresentes += parseFloat(response.data[i].valor.replace(',','.'))
            }
            this.valorPresentes = this.valorPresentes.toFixed(2).replace('.',',')
            this.valorSaque = (parseFloat(this.valorPresentes.replace(',','.')) - (parseFloat(this.valorPresentes.replace(',','.')) * this.companyobj.taxaGiftList / 100)).toFixed(2).replace('.',',')
          }
        })
      },

      async carregaQuantidadeCheckins() {
        await axios.get(baseApiUrl + 'Convidados?filter={"where":{"empresaId":"' + this.companyobj.id + '"}}')
        .then(response => {
          if (response.data) {
            response.data.forEach(convidado => {
              if (convidado.checkin && convidado.userValidatorCheckinId == this.user.id) {
                if (convidado.hasOwnProperty("senhasExtra") && convidado.senhasExtra > 0) {
                  this.checkinsRealizados = this.checkinsRealizados + convidado.senhasExtra
                } else {
                  this.checkinsRealizados++
                }
              }

              if (convidado.checkin) {
                if (convidado.hasOwnProperty("senhasExtra") && convidado.senhasExtra > 0) {
                  this.checkinsRealizadosTotal = this.checkinsRealizadosTotal + convidado.senhasExtra
                } else {
                  this.checkinsRealizadosTotal++
                }
              }
            });
          }
        })
      },
    }
  }
</script>

<style>
  .v-data-table th {
    background-color: #90A4AE;
    font-size: 1rem;
    color: white;
  }

  .cardTema {
    background: #ECE9E6;
    background: -webkit-linear-gradient(to right, #FFFFFF, #ECE9E6);
    background: linear-gradient(to right, #FFFFFF, #ECE9E6);
  }

  .theme--light.v-table thead th {
    color: white;
  }

  .theme--light.v-datatable thead th.column.sortable:hover {
    color: rgb(17, 16, 16);
  }

  .span-pesquisa {
    width: 25%;
  }

  .container {
    position: relative;
    min-width: 100%;
    overflow: hidden;
  }

  #create .v-speed-dial {
    position: absolute;
  }

  #create .v-btn--floating {
    position: relative;
  }
</style>
